import { Component } from 'react';

import Logo from 'components/logo';

export default class ErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  componentDidCatch() {
    this.setState({
      hasError: true,
    });
  }

  refreshPage() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      const { header, content, buttonText } = this.props;

      return (
        <div className="errorboundary-h">
          <div className="error-box">
            <div className="err-logo-row">
              <Logo />
            </div>
            <div className="err-info-b">
              <h1 className="err-text-v">
                <span>
                  {header}
                  <br />
                </span>
                {content}
              </h1>
            </div>
            <div className="reg-btn-holder">
              <button onClick={this.refreshPage} className="btn">
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
